import { createAction } from "redux-actions";

import { SET_CURRENT_STATE } from "../store/actions";

export const setCurrentState = createAction(SET_CURRENT_STATE);
